import { Exceptionless } from '@exceptionless/vue'

export function useExceptionless() {
    const logError = (err: unknown, context?: string, tags: string[] = []) => {
        const error = err instanceof Error ? err : new Error(String(err))

        Exceptionless.createException(error)
            .setType(context || "Unhandled Frontend Error")
            .addTags(...tags)
            .submit()
    }

    const logMessage = (message: string, context?: string, tags: string[] = []) => {
        Exceptionless.createLog(message, 'Info')
            .setType(context || "Frontend Log")
            .addTags(...tags)
            .submit()
    }

    return {
        logError,
        logMessage
    }
}